module.exports = __webpack_public_path__ + "img/icon-edit.c33ebe33.svg";